import dlPush from 'gtm';
import * as gaTracker from 'ga.events';
import * as ecTracker from 'ec.events';
import { setDebuggerMode, debuggerMode } from './debugger';
import { setTrackingLibrary } from './trackingLibrary';
import { setSuperProperties } from './events/superProperties';
import serializePurchase from './serializers/purchase';

let trackingLibrary;

export function load(
  token,
  {
    debug = false,
    tracker = 'mixpanel',
    superProps,
    onLoaded = () => {},
    libUrl,
    apiHost,
  } = {}
) {
  setDebuggerMode(debug);

  trackingLibrary = setTrackingLibrary(tracker);
  setSuperProperties(superProps);
  trackingLibrary.load(token, debug, onLoaded, libUrl, apiHost);
}

export function analyticsReady(callback) {
  if (!trackingLibrary) return;
  trackingLibrary.analyticsReady(callback);
}

export function getAnalytics() {
  if (!trackingLibrary) return false;
  return trackingLibrary.getAnalytics();
}

export function identifyUser(userId, traits, options, callback) {
  if (!trackingLibrary) return;
  trackingLibrary.identifyUser(userId, traits, options, callback);
  setSuperProperties({ 'User Type': traits['User Type'] || 'Registered' });

  if (debuggerMode()) {
    console.info(`Analytics ➞ User identified: ${userId}`, traits);
  }
}

export function userAlias(newId, previousId, traits, options, callback) {
  if (!trackingLibrary) return;
  trackingLibrary.userAlias(newId, previousId, traits, callback);
  setSuperProperties({ 'User Type': traits['User Type'] || 'Registered' });

  if (debuggerMode()) {
    console.info(`Analytics ➞ User alias: ${newId}`, traits);
  }
}

export function setUserProperties(traits, callback, setOnce = false) {
  if (!trackingLibrary) return;
  setSuperProperties({ 'User Type': traits['User Type'] || 'Anonymous' });
  trackingLibrary.setUserProperties(traits, callback, setOnce);

  if (debuggerMode()) console.info('Analytics ➞ Set user properties', traits);
}

export function resetUser() {
  if (!trackingLibrary) return;
  trackingLibrary.resetUser();

  if (debuggerMode()) console.info('Analytics ➞ User reset');
}

export function getDistinctId() {
  if (!trackingLibrary) return '';
  return trackingLibrary.getDistinctId();
}

// analytics core event methods exports
export * from 'events/core';

// google analytics events methods exports
export { gaTracker };

// enhanced ecommerce events methods exports
export { ecTracker };

// GTM data layer push
export { dlPush };

// export serializers
export { serializePurchase };



// WEBPACK FOOTER //
// ./index.js